import { fallbackPages, fallbackTeam, fallbackGalleries } from "../data";

const API_BASE = "https://api.dev.auxo.dk/public";

export async function fetchPages() {
  try {
    const res = await fetch(`${API_BASE}/content/pages`);
    if (!res.ok) throw new Error("Failed to fetch pages");
    const data = await res.json();
    return data;
  } catch (error) {
    console.warn("CMS fetch failed, using fallback pages:", error);
    // Map fallback pages to API structure
    return Object.entries(fallbackPages).map(([slug, page]) => ({
      slug: { da: slug },
      title: page.title,
      meta_description: page.meta_description,
      content: page.content,
      images: page.images,
    }));
  }
}

export async function fetchTeamMembers() {
  try {
    const res = await fetch(`${API_BASE}/content/team_members`);
    if (!res.ok) throw new Error("Failed to fetch team members");
    const data = await res.json();
    return data;
  } catch (error) {
    console.warn("CMS fetch failed, using fallback team:", error);
    return fallbackTeam;
  }
}

export async function fetchGalleries() {
  try {
    const res = await fetch(`${API_BASE}/content/gallery`);
    if (!res.ok) throw new Error("Failed to fetch galleries");
    const data = await res.json();
    return data;
  } catch (error) {
    console.warn("CMS fetch failed, using fallback galleries:", error);
    return Object.entries(fallbackGalleries).map(([slug, images]) => ({
      slug: { da: slug },
      title: slug.charAt(0).toUpperCase() + slug.slice(1),
      images,
    }));
  }
}
